(() => {
  angular
    .module('app.core')
    .controller('SurveyController', Survey);

  Survey.$inject = [
    '$sce',
    '$interval',
  ];

  function Survey(
    $sce,
    $interval,
  ) {
    const vm = this;
    vm.open = false;
    vm.submit = false;
    vm.sessions = [];

    // const localReadArray = key => JSON.parse(localStorage.getItem(key) || '[]');
    // const localWriteArray = (key, data) => { localStorage.setItem(key, JSON.stringify(data)); };

    const user = $('#current-user');
    const headers = () => ({
      headers:  {
        'content-type': 'application/json',
        'Authorization': `Bearer ${vm.idToken}`,
      },
    });
    const endpoint = `${user.data('apapi')}/org/v1/users/me/bucket`;
    const params = Object.entries({
      organisation_id: user.data('company-id'),
      organisation_name: user.data('company'),
      user_name: user.data('username'),
      user_email: user.data('email'),
    }).map(([param, value]) => `${param}=${value}`).join('&');
    const dataLayer = window.dataLayer.find(item => item.env);
    const typeformHost = 'https://37l7x0zo89u.typeform.com';
    const typeformId = dataLayer.env === 'production' ? 'dj0cpEpV' : 'TtQLeD0t';

    vm.src = $sce.trustAsResourceUrl(`${typeformHost}/to/${typeformId}#${params}`);

    const handleMessage = event => {
      if (event.origin === typeformHost && event.data.type === 'form-submit') {
        vm.submit = true;
        updateExpiresIn();
      }
    };

    const getSurveySessions = () => fetch(`${endpoint}/ar-survey-sessions`, headers())
      .then(response => response.json())
      .then(json => {
        const today = new Date();
        const date = `${today.getFullYear()}${today.getMonth()}${today.getDate()}`;

        vm.sessions = Array.from(new Set(json.data.value ? JSON.parse(json.data.value) : []).add(date));
        if (vm.sessions.length > 5) {
          vm.sessions.shift();
        }

        return json;
      });

    const updateSurveySessions = () => fetch(endpoint, {
      ...headers(),
      method: 'put',
      body: JSON.stringify({
        key: 'ar-survey-sessions',
        value: JSON.stringify(vm.sessions),
        expires_in: 365 * 24 * 60 * 60,
      })
    });

    const getSurveyStatus = () => {
      if (vm.sessions.length < 5) {
        return false;
      }

      return fetch(`${endpoint}/ar-survey`, headers())
        .then(response => response.json())
        .then(json => {
          vm.open = !json.data.key;
          if (vm.open) {
            window.addEventListener('message', handleMessage);
          }
        });
    };

    const updateExpiresIn = () => fetch(endpoint, {
      ...headers(),
      method: 'put',
      body: JSON.stringify({
        key: 'ar-survey',
        value: 'classic',
        expires_in: (vm.submit ? 365 : 180) * 24 * 60 * 60,
      })
    });

    vm.handleClose = () => {
      if (!vm.submit) {
        updateExpiresIn();
      }

      vm.open = false;
      window.removeEventListener('message', handleMessage);
    };

    const interval = $interval(() => {
      vm.idToken = localStorage.getItem('idToken');

      if (vm.idToken) {
        getSurveySessions()
          .then(updateSurveySessions)
          .then(getSurveyStatus)

        $interval.cancel(interval);
      }
    }, 300);
  }
})();
